import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.Loading)?_c(VApp,[_c(VMain,{staticClass:"mx-0 wrap",attrs:{"fill-height":""}},[(!_vm.IsInitializedError)?_c('router-view'):_vm._e(),_c('wp-notification',{attrs:{"bottom":""}})],1),_c('v-offline',{on:{"detected-condition":_vm.OnlineStatusChange}}),(_vm.IsOffline)?_c('wp-error'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }